
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M22 12.9091V10.6364L19.0473 10.2336C18.8737 9.54061 18.598 8.87728 18.2291 8.26545L20.0327 5.89273L18.1073 3.96455L15.7345 5.76818C15.1227 5.39929 14.4594 5.12354 13.7664 4.95L13.3636 2H10.6364L10.2336 4.95273C9.54061 5.12627 8.87728 5.40202 8.26545 5.77091L5.89273 3.96455L3.96455 5.89273L5.76818 8.26545C5.39929 8.87728 5.12354 9.54061 4.95 10.2336L2 10.6364V12.9091"></path><path d="M6.00255 17.0678C5.67437 16.7448 5.22405 16.5455 4.72718 16.5455C3.72302 16.5455 2.909 17.3595 2.909 18.3636C2.909 19.3678 3.72302 20.1818 4.72718 20.1818C5.73133 20.1818 6.54536 19.3678 6.54536 18.3636C6.54536 17.8564 6.33761 17.3976 6.00255 17.0678ZM6.00255 17.0678L8.36078 14.699V12.9359"></path><path d="M17.9703 17.0951C17.6512 17.4227 17.4546 17.8702 17.4546 18.3637C17.4546 19.3678 18.2687 20.1818 19.2728 20.1818C20.277 20.1818 21.091 19.3678 21.091 18.3637C21.091 17.3595 20.277 16.5455 19.2728 16.5455C18.7621 16.5455 18.3006 16.756 17.9703 17.0951ZM17.9703 17.0951L15.6406 14.7328V12.8795"></path><path d="M11.9999 18.3636C10.9957 18.3636 10.1817 19.1777 10.1817 20.1818C10.1817 21.186 10.9957 22 11.9999 22C13.004 22 13.8181 21.186 13.8181 20.1818C13.8181 19.1777 13.004 18.3636 11.9999 18.3636ZM11.9999 18.3636V12.9283"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiApi",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
